module.exports = __webpack_public_path__ + "media/images/help/flow/bg-rail-sm-da8892ec6569c19ded3a9426aed21751.svg";